import { gql } from '@apollo/client'

export const GET_DXO_EXECUTION_AVERAGE_BASELINE = gql`
  query GetDXOExecutionAverageBaseline(
    $input: AdminDashboardIntervalReportInput!
  ) {
    dxoAverageBaselineIntervalReport(input: $input) {
      groupId
      date
      averageCompliant
    }
  }
`
